import { FormattedMessage } from "react-intl";

type Props = {
  children?: React.ReactNode;
  cookieConsentVisible?: boolean;
  notification?: React.ReactNode;
};

function Template({
  children,
  cookieConsentVisible = false,
  notification = null,
}: Props) {
  return (
    <span className="root-layout">
      <div
        className={
          cookieConsentVisible
            ? "cyan-stripe content-wrapper cookie"
            : "cyan-stripe content-wrapper"
        }
      >
        {notification}
        <div id="root-content">{children}</div>
      </div>
      <footer className={cookieConsentVisible ? "cookie" : ""}>
        <div className="container">
          <ul>
            <li>Copyright © Endress+Hauser Process Solutions AG</li>
            <li>
              <a href="/app/id/legal/imprint">
                <FormattedMessage id="footer.imprint" />
              </a>
            </li>
            <li>
              <a href="/app/id/legal/terms-of-service">
                <FormattedMessage id="footer.terms" />
              </a>
            </li>
            <li>
              <a href="/app/id/legal/privacy-policy">
                <FormattedMessage id="footer.privacy" />
              </a>
            </li>
            <li>
              <a href="https://help.netilion.endress.com/">
                <FormattedMessage id="footer.help" />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </span>
  );
}

export default Template;
